// キープ（ストック）バー。タップした語をためて、まとめてコピーできる下部固定バー。

import { useCallback, useEffect, useState } from 'react'
import { addKeep, loadKeep, removeKeep, saveKeep } from './keepStore'

/** キープ語リストの状態管理。localStorage と同期する。 */
export function useKeep() {
  const [items, setItems] = useState<string[]>(() => loadKeep(localStorage))

  useEffect(() => {
    saveKeep(localStorage, items)
  }, [items])

  const add = useCallback((word: string) => {
    setItems((cur) => addKeep(cur, word))
  }, [])
  const remove = useCallback((word: string) => {
    setItems((cur) => removeKeep(cur, word))
  }, [])
  const clear = useCallback(() => {
    setItems([])
  }, [])

  return { items, add, remove, clear }
}

export function KeepBar({
  items,
  onRemove,
  onClear,
  onCopyAll,
}: {
  items: string[]
  onRemove: (word: string) => void
  onClear: () => void
  onCopyAll: (text: string) => void
}) {
  const [open, setOpen] = useState(false)

  if (items.length === 0) return null

  return (
    <div className="fixed inset-x-0 bottom-0 z-20">
      {open && (
        <div className="mx-auto max-w-4xl border-t border-line bg-card px-4 pb-2 pt-3 shadow-sm">
          <div className="flex flex-wrap gap-1.5">
            {items.map((w) => (
              <button
                key={w}
                type="button"
                onClick={() => onRemove(w)}
                aria-label={`${w} をキープから削除`}
                className="rounded-full border border-line bg-paper px-2.5 py-1 text-sm text-ink hover:border-accent-pink/60 hover:text-accent-pink"
              >
                {w}
              </button>
            ))}
          </div>
          <div className="mt-2 flex gap-2 text-sm">
            <button
              type="button"
              onClick={() => onCopyAll(items.join('\n'))}
              className="rounded-lg bg-accent-vio px-3 py-1.5 font-semibold text-white"
            >
              まとめてコピー
            </button>
            <button
              type="button"
              onClick={onClear}
              className="rounded-lg border border-line bg-paper px-3 py-1.5 text-mut hover:text-ink"
            >
              クリア
            </button>
          </div>
        </div>
      )}
      <div className="mx-auto flex max-w-4xl justify-center px-4 pb-3">
        <button
          type="button"
          data-testid="keep-bar"
          onClick={() => setOpen((v) => !v)}
          aria-expanded={open}
          className="rounded-full bg-accent-vio px-4 py-2 text-sm font-semibold text-white shadow-lg"
        >
          キープ {items.length}語 {open ? '▼' : '▲'}
        </button>
      </div>
    </div>
  )
}
